import {
  AffiliateRankingListData,
  AffiliateReportSummary,
} from '@/@types/AffiliateReport';
import {
  AffiliateRankingEntryRaw,
  AffiliateReportRankingsResponse,
  AffiliateReportSummaryResponse,
} from '@/@types/GlobalAffiliateReportResponse';

export function buildSummaryFromApi(
  raw: AffiliateReportSummaryResponse,
): AffiliateReportSummary {
  return {
    totalRevenue: raw.total_revenue,
    totalCommissions: raw.total_commissions,
  };
}

function toRankingEntry(raw: AffiliateRankingEntryRaw) {
  return {
    id: raw.id,
    name: raw.name,
    avatarUrl: raw.avatarUrl,
    primaryValue: raw.primaryValue,
    numericValue: raw.numericValue,
  };
}

export function buildRankingsFromApiResponse(
  rankings: AffiliateReportRankingsResponse['rankings'] | undefined,
  labels: Record<string, string>,
): AffiliateRankingListData[] {
  if (!rankings) return [];

  const emptyMessage = labels.empty ?? '';

  return [
    {
      key: 'revenue',
      title: labels.topRevenue ?? '',
      emptyMessage,
      entries: rankings.revenue.map(toRankingEntry),
    },
    {
      key: 'aov',
      title: labels.topAov ?? '',
      emptyMessage,
      entries: rankings.aov.map(toRankingEntry),
    },
    {
      key: 'profit',
      title: labels.topProfit ?? '',
      emptyMessage,
      entries: rankings.profit.map(toRankingEntry),
    },
    {
      key: 'refund',
      title: labels.topRefund ?? '',
      emptyMessage,
      entries: rankings.refund.map(toRankingEntry),
    },
    {
      key: 'chargeback',
      title: labels.topChargeback ?? '',
      emptyMessage,
      entries: rankings.chargeback.map(toRankingEntry),
    },
  ];
}
